import styled from 'styled-components';

export const RedirectFooter = styled.p`
  margin: 0;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: var(--v3-primary-color);
  text-align: left;

  &:hover {
    cursor: pointer;
  }
`;
